<template>
  <div class="approved-approval">
    <div class="text-right">
      <a-button slot="extra" @click="goBack">返回</a-button>
    </div>
    <!-- 审批流程 -->
    <a-card title="审批流程" :loading="loading" class="card">
      <process :process-list="process" />
    </a-card>
    <!--基本信息-->
    <a-card title="基本信息">
      <a-row>
        <a-col :span="8">企业申请数量: {{ baseInfo.total }}</a-col>
        <a-col :span="8">
          下载申请名单:
          <span class="name" @click="handleDownload(baseInfo.id)">
            {{ baseInfo.fileName }}
          </span>
        </a-col>
      </a-row>
    </a-card>
    <!--申请信息-->
    <a-card style="margin-top:20px;" title="申请信息">
      <!-- 申请原因及备注 -->
      <apply-reason-remark :content="remark || ''" :attachments="attachments" />
    </a-card>
    <!-- 审批意见 -->
    <a-card
      title="审批意见"
      class="card"
      :loading="loading"
      style="margin-top:20px;"
      v-if="status == 1 || (status == 2 && show !== 0)"
    >
      <quill-editor
        :token="token"
        ref="quillEditor"
        v-if="show === 0"
      ></quill-editor>
      <Approval-reason-remark :content="remarktwo || ''" v-if="show !== 0" />
    </a-card>

    <footer-tool-bar v-if="status == 1">
      <a-button
        type="primary"
        class="margin-right-20"
        @click="handleSubmit(APPROVAL_ACTION_OBJ.PASS)"
        :loading="loading"
      >
        审批通过
      </a-button>
      <a-button
        type="danger"
        class="margin-right-20"
        @click="handleSubmit(APPROVAL_ACTION_OBJ.REJECT)"
        :loading="loading"
      >
        审批不通过
      </a-button>
    </footer-tool-bar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getApplyList, doApprove, downloadAttachment } from './api'
import Process from './../credit-approval/components/Process.vue'
import { APPROVAL_ACTION_OBJ } from './const'
import ApplyReasonRemark from './apply/ApplyReasonRemarkView.vue'
import ApprovalReasonRemark from './apply/ApprovalReasonRemarkView.vue'
import FooterToolBar from 'components/FooterToolBar.vue'
import QuillEditor from './../credit-approval/components/QuillEditor.vue'
export default {
  data() {
    //这里存放数据
    return {
      baseInfo: {},
      loading: false,
      process: [],
      companyCode: '',
      status: '',
      remarktwo: '',
      remark: '',
      show: 0,
      bpmId: '',
      APPROVAL_ACTION_OBJ,
      attachments: [],
    }
  },
  components: {
    QuillEditor,
    FooterToolBar,
    Process,
    ApplyReasonRemark,
    ApprovalReasonRemark,
  },
  computed: {
    ...mapGetters('user', ['token']),
  },
  //方法集合
  methods: {
    // 点击文件链接下载
    handleDownload(id) {
      downloadAttachment(id)
    },
    goBack() {
      this.$router.go(-1)
    },
    async handleSubmit(ack) {
      this.loading = true
      try {
        if (ack == APPROVAL_ACTION_OBJ.REJECT) {
          const query = {
            ack,
            id: this.baseInfo.id,
            bpmId: this.bpmId,
            remark: this.$refs.quillEditor.getContent(),
          }
          const { code, message } = await doApprove(query)
          if (code === '0000') {
            this.$message.success(message)
            this.$router.push({
              name: 'group-relationship-mana',
            })
          }
        } else {
          const query = {
            ack,
            id: this.baseInfo.id,
            bpmId: this.bpmId,
            remark: this.$refs.quillEditor.getContent(),
          }
          const { code, message } = await doApprove(query)
          if (code === '0000') {
            this.$message.success(message)
            this.$router.push({
              name: 'group-relationship-mana',
            })
          }
        }
      } catch (error) {
        this.loading = false
        console.log(error)
      }
    },
    async _getApplyList(bpmId) {
      const { data } = await getApplyList(bpmId)
      this.process = data.process
      this.baseInfo = data
      this.attachments = data.attachments
      this.remark = data.remark
      this.show = data.process[1].status
      this.remarktwo = data.process[1].assigners[0].remark
    },
  },
  //生命周期 - 创建完成（访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（访问DOM元素）
  mounted() {
    this.status = this.$route.query.status
    this.bpmId = this.$route.params.id
    this._getApplyList(this.bpmId)
  },
}
</script>
<style scoped>
.name {
  color: #409eff;
  cursor: pointer;
}
/* @import url(); 引入css类 */
</style>
